import { useCallback, useRef } from 'react';
import { Box } from '@radix-ui/themes';
import styles from './SnippetDetail.module.scss';
import { Editor, type EditorRef } from "@/v2/components/editor/Editor";
import { FloatingMediaButtons } from './FloatingMediaButtons';

interface SnippetDetailContentProps {
  content: string;
  onChange?: (content: string) => void;
  editable?: boolean;
  snippetId?: string;
}

export function SnippetDetailContent({
  content,
  onChange,
  editable = true,
  snippetId
}: SnippetDetailContentProps) {
  const editorRef = useRef<EditorRef>(null);

  const handleAddImage = useCallback((url: string) => {
    editorRef.current?.insertImage(url);
  }, []);

  const handleAddVideo = useCallback((url: string) => {
    editorRef.current?.insertVideo(url);
  }, []);

  return (
    <>
      <Box className={styles.content} px="3">
        <Editor
          ref={editorRef}
          content={content}
          onChange={onChange}
          editable={editable}
          showMarkdownToggle={false}
          showToolbar={false}
          snippetId={snippetId}
        />
      </Box>
      {editable && snippetId && (
        <FloatingMediaButtons
          snippetId={snippetId}
          onAddImage={handleAddImage}
          onAddVideo={handleAddVideo}
        />
      )}
    </>
  );
}
